/**
 * Adapt from OperationTag in swagger-ui:
 * https://github.com/swagger-api/swagger-ui/blob/4d9ec4fb0eaaddb7e1a8f4502e8e8577d40e46ec/src/core/components/operation-tag.jsx#L6
 */
import React from 'react';
import { Grid, Typography } from '@rbx/ui';
import Im from 'immutable';
import PropTypes from 'prop-types';
import { createDeepLinkPath } from '../utils/coreUtils';
import DLink from './DLink';

export default class DOperationTag extends React.Component<any> {
  static defaultProps = {
    tagObj: Im.fromJS({}),
    tag: '',
  };

  static propTypes = {
    tagObj: PropTypes.object,
    tag: PropTypes.string,

    layoutSelectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,

    getConfigs: PropTypes.func.isRequired,
    getComponent: PropTypes.func.isRequired,

    specUrl: PropTypes.string.isRequired,

    children: PropTypes.element,
  };

  render() {
    const { tagObj, tag, children, layoutSelectors, getConfigs, getComponent, id } = this.props;

    const { docExpansion } = getConfigs();

    const Markdown = getComponent('Markdown', true);
    const DeepLink = getComponent('DeepLink');

    const tagDescription = tagObj.getIn(['tagDetails', 'description'], null);

    const isShownKey = ['operations-tag', tag];
    const showTag = layoutSelectors.isShown(
      isShownKey,
      docExpansion === 'full' || docExpansion === 'list',
    );
    return (
      <Grid container flexDirection='column' item XSmall={12}>
        {tag && tag !== 'Cloud' && tag !== 'default' && (
          <Typography id={id} variant='h3' marginBottom={3}>
            <DLink
              variant='h5'
              component='a'
              underline='none'
              color='inherit'
              href={`#${tag}`}
              data-tag={tag}
              data-is-open={showTag}>
              <DeepLink
                enabled={false}
                isShown={showTag}
                path={createDeepLinkPath(tag)}
                text={tag}
              />
            </DLink>
          </Typography>
        )}
        {!tagDescription ? (
          <small />
        ) : (
          <small>
            <Markdown source={tagDescription} />
          </small>
        )}
        <div className='swagger-ui'>{children}</div>
      </Grid>
    );
  }
}
